import type { Scorecard } from "../api/scorecard";

export const NO_DATE = "—";

/** ISO date only. Deliberately not `toLocaleDateString` — that varies with
 * the runner's locale and timezone, which would make the copied text differ
 * between machines and the test flaky. Exported so the table in
 * WeeklyScorecard renders dates identically to the copied text. */
export function isoDate(value: string | null): string {
  return value ? value.slice(0, 10) : NO_DATE;
}

export function promoLabel(p: { origin_name: string; event_name: string }): string {
  return p.event_name ? `${p.origin_name} / ${p.event_name}` : p.origin_name;
}

export function scorecardText(s: Scorecard): string {
  const lines: string[] = [
    `Weekly Scorecard — 7 days ending ${isoDate(s.window.end)}`,
    "",
    `Total signups in the last 7 days: ${s.totals.signups}`,
    `Total creators verified in the last 7 days: ${s.totals.creator_verifications}`,
    `Total works certified in the last 7 days: ${s.totals.work_certifications}`,
  ];

  for (const p of s.promos) {
    lines.push("", promoLabel(p));
    lines.push(`  Signups: ${p.signups}`);
    lines.push(`  Verifications: ${p.verifications}`);
    if (!p.is_unattributed) {
      lines.push(`  Start date: ${isoDate(p.house_default_start_at)}`);
      lines.push(`  End date: ${isoDate(p.house_default_end_at)}`);
    }
  }

  lines.push("");
  lines.push(
    s.next_promo
      ? `Next promo is "${promoLabel(s.next_promo)}", starting on ${isoDate(
          s.next_promo.house_default_start_at,
        )}`
      : "No next promo scheduled",
  );

  return lines.join("\n");
}
